<template>
  <section class="section-base form-section-base mt-5">
    <div class="form-base">
      <v-container fluid class="px-0">
        <v-row id="controls-target">
          <v-col cols="12">
            <div class="form-section-base__title text--black">
              {{titleText}}
              <div class="form-base__tooltip">
                <v-icon large>{{ mdiAlertCircleOutline }}</v-icon>
                <span class="text">{{ titleHint }}</span>
              </div>
            </div>
          </v-col>
          <v-col cols="12" v-if="autoRegionSelect">
            <div class="form-section-base__title text pt-1 pb-3">
              Регион распределения:
              <span class="form-base__label text font-weight-regular">
                {{ regionName }}
              </span>
            </div>

          </v-col>
          <v-col cols="6" v-if="!autoRegionSelect">
            <div class="form-base__label text pt-1 pb-3">
              {{ selectRegionText }}:
            </div>
            <v-autocomplete
              :value="regionCode"
              :errorMessages="errorMessages"
              :disabled="disabled"
              :items="regions"
              outlined
              label="Выбор субъекта РФ"
              no-data-text="Нет данных"
              item-text="regionName"
              item-value="regionCode"
              @change="regionCodeChangeHandler"
              :filter="
                (item, queryText) => {
                  return (
                    item.regionName
                      .toLocaleLowerCase()
                      .indexOf(queryText.toLocaleLowerCase()) > -1
                  );
                }
              "
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title
                    >{{ data.item.regionName }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="6" v-if="!autoRegionSelect">
            <div class="form-base__label text pt-1 pb-3" v-if="isAcceptanceDeposit">
                Выбрать нотариальный округ в данном субъекте:
            </div>
            <v-checkbox
              v-else
              class="mb-3"
              v-model="canSelectDistrict"
              label="Выбрать нотариальный округ в данном субъекте:"
              hide-details
              :disabled="
                isDistrictCheckboxDisabled || districtAlways || disabled
              "
            />
            <v-autocomplete
              no-data-text="Нет данных"
              outlined
              :disabled="!canSelectDistrict || disabled"
              label="Выбор округа"
              :loading="isDistrictsLoading"
              :items="districts"
              :value="districtId"
              @change="$emit('district-id-change', $event)"
              :errorMessages="errorMessageDistrict"
              item-text="name"
              item-value="districtId"
              :filter="
                (item, queryText) => {
                  return (
                    item.name
                      .toLocaleLowerCase()
                      .indexOf(queryText.toLocaleLowerCase()) > -1
                  );
                }
              "
            />
          </v-col>
        </v-row>

        <v-row v-if="regionHistory && regionHistory.length && autoRegionSelect">
          <v-col>
            <span class="region-history">
              <span class="region-history__title">
                История распределения:
              </span>
              <span v-for="(region, index) in regionHistory" :key="index">
                {{ region }}
              </span>
            </span>
          </v-col>
        </v-row>

        <v-row v-if="isMapVisible">
          <v-col>
            <Map
              @region-click="regionClickHandler"
              :region-code="regionCode"
              :disabled="disabled"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
import {mdiAlertCircleOutline} from '@mdi/js';

import Map from '@/components/map/Map';
import {RegionModule} from '@/store/modules/region';
import {MapModule} from '@/store/modules/map';
import {RouteName} from '@/router';
import {isMapVisible, noticeRecoveryRegion} from '@/app.config';
import {StatementType} from '@/types/services';
import {ServicesModule} from '@/store/modules/services'
import {AltDistrictModule} from "@/store/modules/alternativeServices/altDistrict";
import {StatementStatusInfoModule} from "@/store/modules/statementStatusInfo";
import {StatementStatus} from "@/constants";

export default {
  name: 'MapElement',
  components: { Map },
  props: {
    regionCode: {
      type: String,
    },
    districtId: {
      type: String,
    },
    errorMessages: {
      type: Array,
    },
    errorMessageDistrict: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    districtAlways: {
      type: Boolean,
      required: false,
      default: false,
    },
    statementType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isMapVisible,
    RouteName,
    mdiAlertCircleOutline,
    canSelectDistrict: false,
    isDistrictCheckboxDisabled: false,
    debtorAddress: ''
  }),

  async mounted() {
    if (!RegionModule.loading && !RegionModule.loaded) {
      await RegionModule.loadRegionsAll();
    }

    if (this.districtAlways) this.canSelectDistrict = true;

    if (this.districtId) {
      this.canSelectDistrict = true;
      this.isDistrictCheckboxDisabled = false;
    }

    if (this.isAcceptanceDeposit) {
      this.districtAlways = true
      this.canSelectDistrict = !this.isFederalCity(this.regionCode);
    }
    this.selectRegion()
  },

  watch: {
    async regionCode(regionCode) {
      this.clearDistrict();
      await MapModule.loadDistricts(regionCode);
      this.isDistrictCheckboxDisabled = this.isFederalCity(regionCode);

      if (this.isAcceptanceDeposit) {
        this.canSelectDistrict = !this.isFederalCity(regionCode)
      }
    },

    canSelectDistrict(val) {
      if (!val) this.clearDistrict();
    },
    originalStatus(val) {
      if (val === StatementStatus.REJECTED_FROM_FSSP) return
      this.selectRegion(true)
    },
    statement: {
      handler: function () {
        this.selectRegion()
      },
      deep: true,
    },
    regions() {
      this.selectRegion()
    }
  },

  computed: {
    originalStatus () {
      return StatementStatusInfoModule.entity?.statusCode || ''
    },
    isAlternativeServiceEdit() {
      return this.$route.name.startsWith(RouteName.ALTERNATIVE_SERVICE_EDIT);
    },
    statement() {
      return ServicesModule.statement
      || AltDistrictModule.dataStatement
      || {}
    },
    regionHistory() {
      if (!AltDistrictModule.dataStatement) return []
      let regions = []
      if (
          !AltDistrictModule.dataStatement?.regionHistory.length
          && this.regionCode
          && AltDistrictModule.dataStatement.locationStep
          && AltDistrictModule.dataStatement.locationStep.regionCode !== this.regionCode
      ) {
        regions.push(AltDistrictModule.dataStatement.locationStep.regionName)
      } else {
        regions = AltDistrictModule.dataStatement?.regionHistory || []
      }
      return regions
    },
    regionName() {
      if (!this.regions.length || !this.regionCode) return ''
      return this.regions.filter((item) => item.regionCode === this.regionCode)[0]?.regionName || ''
    },
    autoRegionSelect() {
      return this.statementType === StatementType.NOTICE_RECOVERY && noticeRecoveryRegion
    },
    titleText() {
      return this.autoRegionSelect
        ? `Заявление будет направлено по месту жительства или пребывания должника в субъекте Российской Федерации`
        : `Заявление может быть направлено по месту совершения нотариального
           действия в субъекте Российской Федерации или в нотариальный округ
           в определенном субъекте РФ (по желанию заявителя)`
    },
    titleHint() {
      return this.autoRegionSelect
        ? `В случае, если по истечении 60 минут ни один нотариус не примет в работу заявление,
           Вам будет направлено уведомление о необходимости повторно направить заявление
           (например: ночное время в указанном субъекте РФ, распределение на малонаселенный субъект,
           где мало нотариусов).`
        : `В случае, если по истечении 60 минут ни один нотариус не
           примет в работу заявление, Вам будет направлено уведомление о
           необходимости повторно направить заявление или изменить выбор
           места совершения нотариального действия (например: ночное
           время в указанном субъекте РФ, вы выбрали малонаселенный
           субъект, где мало нотариусов).`
    },

    regions() {
      return this.statementType === StatementType.EGRN_CONFIRM
          ? RegionModule.egrnConfirmRegions
          : RegionModule.list
    },

    districts() {
      return MapModule.districts.entity;
    },

    isDistrictsLoading() {
      return MapModule.districts.loading;
    },

    selectRegionText() {
      return this.isMapVisible
        ? 'Выберите регион на карте или из списка'
        : 'Выберите регион из списка';
    },

    isAcceptanceDeposit() {
      return this.statementType === StatementType.ACCEPTANCE_DEPOSIT;
    },
  },

  methods: {
    selectRegion(altServiceAllow = false) {
      if (this.isAlternativeServiceEdit && !altServiceAllow) return

      this.debtorAddress = ServicesModule.statement?.subjects?.debtor?.person?.address
        || AltDistrictModule.dataStatement?.subjects?.debtor?.person?.address
        || ServicesModule.statement?.subjects?.debtor?.organization?.address
        || AltDistrictModule.dataStatement?.subjects?.debtor?.organization?.address
        || ServicesModule.statement?.subjects?.debtor?.foreignOrganization?.address
        || AltDistrictModule.dataStatement?.subjects?.debtor?.foreignOrganization?.address
        || ''

      if (!AltDistrictModule) {
       this.debtorAddress = ServicesModule.statement?.subjects?.debtor?.person?.address
        || ServicesModule.statement?.subjects?.debtor?.organization?.address
        || ServicesModule.statement?.subjects?.debtor?.foreignOrganization?.address 
        || ''
      }
      if (this.debtorAddress && this.regions.length && this.autoRegionSelect ) {
        this.regionCodeChangeHandler(this.regions.filter((item) => item.regionFIASId === this.debtorAddress.regionFiasId)[0]?.regionCode || '')
      }
    },
    async regionCodeChangeHandler(regionCode) {
      this.$emit('region-code-change', regionCode);
    },

    isFederalCity(code) {
      return ['77', '78', '92'].includes(code);
    },

    async regionClickHandler(regionCode) {
      if (regionCode === this.regionCode) return;

      await this.regionCodeChangeHandler(regionCode);
      await this.$vuetify.goTo('#controls-target', { duration: 500 });
    },

    clearDistrict() {
      this.$emit('district-id-change', null);

      if (!this.districtAlways) this.canSelectDistrict = false;
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  margin-top: 30px;
}
.region-history {
  display: flex;
  flex-direction: column;
  width: min-content;
  white-space: nowrap;

  padding: 8px 15px 15px 15px;

  border: 3px #7B8DAD solid;
  &__title {
    color: #234177;
  }
}
</style>
